import { lazy } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { DEFAULT_ROUTE } from "../../routing/routes.config";

const ReportsPage = () => {
    const { path } = useRouteMatch();
    const AnnualReportList = lazy(() => import('./features/AnnualReportList'));

    return (
        <Switch>
            <Route exact path={`${path}`} component={AnnualReportList}/>
            <Redirect to={DEFAULT_ROUTE}/>
        </Switch>
    )
}

export default ReportsPage;